import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SplashScreen } from '@capacitor/core';
import { AlertController, MenuController, Platform } from '@ionic/angular';
import { ToolsProvider } from './provider/tools/tools';
import { ThemeService } from './services/theme.service';
import { HttpClient } from '@angular/common/http';
import { BaseUrl } from './service/Configuration';
import { LoginPage } from './Page/login/login.page';
import { HomePage } from './Page/home/home.page';
import { ResourceLoader } from '@angular/compiler';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isAdmin = null;
  userName = '';
  Foto = '';
  Departamento = '';
  appPages: any[];
  usuarios = [];
  selectUsuario = null;

  dark = false;

  constructor(
    private platform: Platform,
    private router: Router, public alertController: AlertController,
    public menu: MenuController, private tool: ToolsProvider,
    private themeService: ThemeService, private http: HttpClient) {

      this.selectUsuario = this.isAdmin;
    this.user();
    this.tool.viewStorage('UsuarioDH').then((data) => {
      if(data!==null){
        this.pages(data.TipoUsuario);
      }
     
    });
  }

  getTipoUsuario(){ // Tipo de usuarios
    this.http.get(BaseUrl + 'api/TipoUsuario').subscribe((Response: any) => {
      this.usuarios = Response;
    });
  }

  pages(isAdmin){ // opciones de usuario
    
    if(isAdmin!==null){
        // this.tool.showLoader();

      this.http.get(BaseUrl + 'api/OpMenu?TipoUsuario=' + isAdmin).subscribe((Response: any) => {

        this.appPages = Response;
        
        // this.tool.hideLoader();

      }, (err) => {
        this.tool.hideLoader()
        
        console.log(err);
        });
    }


  }

  onChange(event){ // cambiar usuario
    if (event.detail.value == 1){
      this.tool.saveStorage('isAdmin', true).then(() => {});
    }
    if(event.detail.value != 1){
      this.tool.saveStorage('isAdmin', null).then(() => {});
    }

    if (event.detail.value == 5){
      this.tool.saveStorage('isConta', true).then(() => {});
    }
    if(event.detail.value != 5){
      this.tool.saveStorage('isConta', false).then(() => {});
    }
      
    this.tool.viewStorage('UsuarioDH').then((data) => {
        if(data !== null){
          this.pages(event.detail.value);
          this.router.navigate(['/home']);
        }
     });

    }

  Logout(){
    // this.tool.saveStorage(Key, null).then(() => {
    // });
    this.router.navigate(['/login']);
    location.reload();
    this.preventBack();
    setTimeout('preventBack()', 0);
    window.onunload = function() { location.reload(); this.menu.enanle(true); };
  }

  async Salir() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Confirmar',
      message: '¿Desea salir?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'Si',
          handler: () => {
            console.log('Confirm Okay');
            this.preventBack();
            setTimeout('preventBack()', 0);
            // tslint:disable-next-line:only-arrow-functions
            window.onunload = function() { location.reload(); };
            this.Logout();
            this.tool.saveStorage('UsuarioDH', null);
            this.tool.saveStorage('isAdmin', null);
            this.tool.RemoveStorage('Token');
            this.tool.RemoveStorage('refreshToken');
            this.menu.enable(false);
          }
        }
      ]
    });
    await alert.present();
  }

  preventBack() { window.history.forward(); this.menu.enable(false); }

   user(){
    this.tool.viewStorage('UsuarioDH').then(async (data) => {
      if(data!==null){
        this.userName = await data.Nombre;
      this.Foto = await data.Foto;
      this.isAdmin = await data.TipoUsuario;
      this.Departamento = await data.Departamento;
      this.pages( data.TipoUsuario);
      }
      // return await data;
    });

    this.tool.saveStorage('isAdmin',false)
    // this.LoginPage.LastConfiguration.User= this.userName;
  }



  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {
    this.tool.viewStorage('UsuarioDH').then(async (data) => {
      if (data == null){
        this.router.navigate(['/login']);
      }else {
        this.router.navigate(['/home']);
      }

    });


    this.user();
    this.pages(this.isAdmin);
    this.getTipoUsuario();
    this.tool.viewStorage('Theme').then((data) => {
      this.dark = data;
      this.themeService.setAppTheme(data);
    });

  }

  onClick(event){

     this.themeService.setAppTheme(event.detail.checked);
     this.dark = event.detail.checked;
  }

}
